import(/* webpackMode: "eager" */ "/home/ec2-user/reyner.giovanni/one21-company-site/production/current/src/app/[type]/client-page.js")